/* Amsterdam Herbal — buy box (sizes, Subscribe & Save, quantity, add to bag) */
(function () {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat('en-GB', { style: 'currency', currency: currency || 'GBP' }).format(cents / 100);
    } catch (e) {
      return '£' + (cents / 100).toFixed(2);
    }
  }

  function initBuy(box) {
    if (box.__ahReady) return;
    var dataEl = box.querySelector('script[data-ah-product]');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!data.variants || !data.variants.length) return;
    box.__ahReady = true;

    var currency = box.getAttribute('data-currency') || 'GBP';
    var firstAvailable = data.variants.filter(function (v) { return v.available; })[0] || data.variants[0];
    var state = {
      variant: Number(box.getAttribute('data-default-variant')) || firstAvailable.id,
      mode: data.hasPlans ? (box.getAttribute('data-default-mode') || 'sub') : 'once',
      plan: Number(box.getAttribute('data-default-plan')) || null,
      qty: 1
    };

    function q(sel) { return Array.prototype.slice.call(box.querySelectorAll(sel)); }
    function setText(sel, txt) { q(sel).forEach(function (el) { el.textContent = txt; }); }
    function show(sel, on) { q(sel).forEach(function (el) { el.hidden = !on; }); }
    function variantById(id) {
      for (var i = 0; i < data.variants.length; i++) if (data.variants[i].id === id) return data.variants[i];
      return data.variants[0];
    }
    function subPrice(v) {
      return state.plan && v.plans && v.plans[state.plan] != null ? v.plans[state.plan] : null;
    }
    function unit(v) {
      var sp = subPrice(v);
      return state.mode === 'sub' && sp != null ? sp : v.price;
    }
    function everyText() {
      var b = box.querySelector('[data-plan-id="' + state.plan + '"]');
      return b ? b.getAttribute('data-plan-every') : '';
    }

    function render() {
      var v = variantById(state.variant);
      var isSub = state.mode === 'sub' && subPrice(v) != null;
      var u = unit(v);
      var every = everyText();
      setText('[data-price]', money(u, currency));
      setText('[data-compare]', money(v.price, currency));
      var save = isSub ? Math.round((1 - u / v.price) * 100) : 0;
      setText('[data-save-pct]', save + '%');
      show('[data-sub-only]', isSub);
      show('[data-once-only]', !isSub);
      var grams = parseFloat(v.title);
      setText('[data-per-gram]', grams ? Math.round(u / grams) + 'p per gram' : '');
      setText('[data-size-label]', v.title);
      setText('[data-every]', every);
      setText('[data-qty-value]', String(state.qty));

      q('[data-variant-id]').forEach(function (b) {
        var bv = variantById(Number(b.getAttribute('data-variant-id')));
        b.setAttribute('aria-pressed', String(bv.id === state.variant));
        var p = b.querySelector('[data-variant-price]');
        if (p) p.textContent = money(unit(bv), currency);
      });
      q('[data-mode]').forEach(function (b) {
        b.setAttribute('aria-pressed', String(b.getAttribute('data-mode') === state.mode));
      });
      q('[data-mode-price]').forEach(function (el) {
        var sp = subPrice(v);
        el.textContent = money(el.getAttribute('data-mode-price') === 'sub' && sp != null ? sp : v.price, currency);
      });
      q('[data-plan-id]').forEach(function (b) {
        b.setAttribute('aria-pressed', String(Number(b.getAttribute('data-plan-id')) === state.plan));
      });

      var add = box.querySelector('[data-add]');
      if (add) {
        var total = money(u * state.qty, currency);
        add.disabled = !v.available;
        if (!v.available) add.textContent = add.getAttribute('data-sold-out') || 'Sold out';
        else if (isSub) add.textContent = 'Subscribe · ' + total + ' every ' + every;
        else add.textContent = 'Add to bag · ' + total;
      }
    }

    box.addEventListener('click', function (e) {
      var t = e.target.closest('button');
      if (!t || !box.contains(t)) return;
      if (t.hasAttribute('data-variant-id')) state.variant = Number(t.getAttribute('data-variant-id'));
      else if (t.hasAttribute('data-mode')) state.mode = t.getAttribute('data-mode');
      else if (t.hasAttribute('data-plan-id')) state.plan = Number(t.getAttribute('data-plan-id'));
      else if (t.hasAttribute('data-qty-minus')) state.qty = Math.max(1, state.qty - 1);
      else if (t.hasAttribute('data-qty-plus')) state.qty = Math.min(99, state.qty + 1);
      else if (t.hasAttribute('data-add')) { e.preventDefault(); addToBag(t); return; }
      else return;
      e.preventDefault();
      var err = box.querySelector('[data-error]');
      if (err) err.hidden = true;
      render();
    });

    function addToBag(btn) {
      var v = variantById(state.variant);
      var item = { id: v.id, quantity: state.qty };
      if (state.mode === 'sub' && subPrice(v) != null) item.selling_plan = state.plan;
      var label = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding…';
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [item] })
      })
        .then(function (r) {
          return r.json().then(function (j) {
            if (!r.ok) throw new Error(j.description || j.message || 'Sorry, we couldn’t add that to your bag.');
            return j;
          });
        })
        .then(function () { window.location.href = root + 'cart'; })
        .catch(function (err) {
          btn.disabled = false;
          btn.textContent = label;
          var m = box.querySelector('[data-error]');
          if (m) { m.textContent = err.message; m.hidden = false; }
        });
    }

    render();
  }

  function initAll(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-ah-buy]'), initBuy);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
